module.exports = __webpack_public_path__ + "static/img/son13.5e5b559f.png";